import { useApi } from 'services';

export const useGetBorrowerBrokerByIdOperation = () => useApi(
    `/v2/credit-analysis/borrower-broker`,
    'GET',
    {},
    {},
    true
);